export default __webpack_public_path__ + "static/truemed-step-2-a2763cc6380d6f0904ab1bbfd0641953.png";